import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import '../styles/GlobalStyle.css'
import { firebase, db } from '../firebase/Firebase'
import { flattenDoc, getQueryStringParam, getStateStandardCategories, getStateStandardNamesDict, getWeekInQuarter, linkAfterLogin } from '.././Util'
import ColType from '.././Types'
import { Layout, BackTop, Spin, Icon, Button, Select } from 'antd'
import CustomFooter from '../login/CustomFooter'
import CastleGame from './castle'
import SpaceGame from './space'
import BasketballGame from './basketball'
import GolfGame from './golf'

const ImageBox = ({ src, style, children, imgScale = 1.3, imgScaleWidth = 1.0,
    imageScaleHeight = 1.0, objectFit = 'contain', top = '50%', left = '50%', onClick, onTouchEnd }) => {
    let styleObj = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: `translate(-50%, -50%)`,
        width: `${imgScale * 100}%`,
        height: `${imgScale * 100}%`,
        objectFit: objectFit,
        pointerEvents: 'none',
        zIndex: 0,
    };
    if (top !== '50%') styleObj.top = top;
    if (left !== '50%') styleObj.left = left;
    if (imgScaleWidth !== 1.0) {
        styleObj.width = `${imgScaleWidth * 100}%`;
    }
    if (imageScaleHeight !== 1.0) {
        styleObj.height = `${imageScaleHeight * 100}%`;
    }
    return <div
        style={{
            position: 'relative',
            // overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'transparent',
            ...style,
        }}
        onClick={onClick}
        onTouchEnd={onTouchEnd}
    >
        <img
            src={src}
            alt=''
            draggable={false}
            style={styleObj}
        />
        <div style={{ position: 'relative', zIndex: 1, width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            {children}
        </div>
    </div>
}

// module level in Games.js
const inc = (n) => firebase.firestore.FieldValue.increment(n)

const SUBJECT_SUFFIX = {
    'Math': 'math', 'Mathematics': 'math',
    'ELA': 'ela', 'English': 'ela', 'Reading': 'ela', 'Writing': 'ela',
    'Science': 'science',
    'Social Studies': 'social_studies', 'History': 'social_studies',
}

const statDocId = (districtId, schoolId, year) =>
    `${districtId}_${schoolId}_${year}`

const MAX_FLUSH_SECONDS = 3600   // cap a single flush slice
const FLUSH_INTERVAL_MS = 60000  // periodic flush so a crash loses ≤60s

class Games extends Component {
    state = {
        gameType: null,
        initialStandardName: '',
        initialStandardCategory: '',
        initialStandard: '',
        initialWeek: 1,
        standardName: '',
        standardCategory: '',
        standard: '',
        standardTitle: '',
        gameQuestionsStandardName: '',
        gameQuestionsStandardCategory: '',
        gameQuestionsStandard: '',
        week: 1,
        index: 0,
        gameQuestions: null,
        pickStandardVisible: false,
        pacingGuide: null,
        pacingGuidesDict: {},
        standardNamesDict: {},
        standardCategories: [],
        init: false,
        autoPlay: false,
        autoPlayGameIdx: 0,
        activeYear: null,
    }
    componentDidMount() {
        const imageNames = [
            '/games/castle/castle-background.png',
            '/games/castle/castle-ladder.png',
            '/games/castle/red-team-climbing.png',
            '/games/castle/blue-team-climbing.png',
            '/games/castle/red-team-wins.png',
            '/games/castle/blue-team-wins.png',
            '/games/castle/scoreboard.png',
            '/games/castle/info-container.png',
            '/games/castle/question-container.png',
            '/games/castle/answer-container.png',
            '/games/castle/correct-incorrect-container.png',
            '/games/space/background.png',
            '/games/space/red-spaceship.png',
            '/games/space/blue-spaceship.png',
            '/games/space/information-container.png',
            '/games/space/question-container.png',
            '/games/space/answer-container.png',
            '/games/space/waypoint-green.png',
            '/games/space/line.png',
            'https://firebasestorage.googleapis.com/v0/b/education-9d7f3.appspot.com/o/basketball-game-background.png?alt=media&token=43551e87-9c06-46de-927d-1b8ea042980e',
            'https://firebasestorage.googleapis.com/v0/b/education-9d7f3.appspot.com/o/basketball-game-answer-container.png?alt=media&token=3054d1f6-5335-4c79-b490-2d9d774d39bf',
            'https://firebasestorage.googleapis.com/v0/b/education-9d7f3.appspot.com/o/basketball-game-question-container.png?alt=media&token=28b56c19-863c-4a28-863c-e758604a1487',
            'https://firebasestorage.googleapis.com/v0/b/education-9d7f3.appspot.com/o/basketball-game-basketball.png?alt=media&token=7cd39c3e-f69f-48f3-87ce-68f48f4332b8',
            'https://firebasestorage.googleapis.com/v0/b/education-9d7f3.appspot.com/o/golf-game-background.png?alt=media&token=c3ec02f9-375c-498d-a62a-ebdd0bf161bc',
            'https://firebasestorage.googleapis.com/v0/b/education-9d7f3.appspot.com/o/golf-game-answer-container.png?alt=media&token=41a0cfbc-e97a-4ab6-b948-47d510adb50d',
            'https://firebasestorage.googleapis.com/v0/b/education-9d7f3.appspot.com/o/golf-game-question-container.png?alt=media&token=2788efe4-32c7-4553-960c-93c373ecd849',
            'https://firebasestorage.googleapis.com/v0/b/education-9d7f3.appspot.com/o/golf-game-golfball.png?alt=media&token=66b16e90-7be1-45d5-9fb3-4da2b38557a1',
        ];
        const preloadedImages = imageNames.map(name => {
            const img = new Image()
            img.src = name;
            return img
        });
        this.setState({ preloadedImages });

        let standardCategory = getQueryStringParam('standardCategory')
        let standardName = getQueryStringParam('standardName')
        let standard = getQueryStringParam('standard')
        let week = getQueryStringParam('week')
        if (week) {
            week = parseInt(week, 10);
        }
        let index = getQueryStringParam('index')
        if (standardCategory && standardName && standard) {
            this.setState({
                initialStandardCategory: standardCategory,
                initialStandardName: standardName,
                initialStandard: standard,
                initialWeek: week || 1,
                standardCategory: standardCategory,
                standardName: standardName,
                standard: standard,
                week: week || 1,
                index: index || 0,
            }, () => {
                this.getGameQuestions();
                this.getPacingGuide();
            })
        }

        this._onVisibility = () => {
            if (document.hidden) {
                this.flushSession()        // best-effort capture before backgrounding
                this.paused = true
            } else if (this.activeGameType) {
                this.lastFlushMs = Date.now()  // don't count time spent backgrounded
                this.paused = false
            }
        }
        document.addEventListener('visibilitychange', this._onVisibility)
        this._flushTimer = setInterval(() => {
            if (this.activeGameType && !this.paused) this.flushSession()
        }, FLUSH_INTERVAL_MS)

        this.loadActiveYear();
    }
    getGameQuestions = async () => {
        if (!(this.props.teacherBaseProps && this.props.teacherBaseProps.district &&
            this.props.pacingGuideBaseProps && this.props.pacingGuideBaseProps.standardYears
        )) {
            return false;
        }
        if (this.state.gameQuestions &&
            this.state.gameQuestions.standard.standardCategory === this.state.standardCategory &&
            this.state.gameQuestions.standard.standardName === this.state.standardName &&
            this.state.gameQuestions.standard.standard === this.state.standard
        ) {
            return false;
        }
        if (this.state.gameQuestionsStandardCategory === this.state.standardCategory &&
            this.state.gameQuestionsStandardName === this.state.standardName &&
            this.state.gameQuestionsStandard === this.state.standard
        ) {
            return false;
        }
        this.setState({
            gameQuestionsStandardCategory: this.state.standardCategory,
            gameQuestionsStandardName: this.state.standardName,
            gameQuestionsStandard: this.state.standard,
            loading: true,
        });
        let districtState = this.props.teacherBaseProps.district.state
        if (districtState === 'NY') {
            districtState = 'SC'
        }
        let standardYears = this.props.pacingGuideBaseProps.standardYears
        const stateAndStandardCategory = districtState + this.state.standardCategory
        if (!standardYears.hasOwnProperty(stateAndStandardCategory)) {
            console.error('standardYears does not have key', stateAndStandardCategory)
            return;
        }
        let standardYear = standardYears[stateAndStandardCategory]
        db.collection(ColType.gameQuestions)
            .where('standard.standardCategory', '==', this.state.standardCategory)
            .where('standard.standardName', '==', this.state.standardName)
            .where('standard.standard', '==', this.state.standard)
            .where('standard.state', '==', districtState)
            .where('standard.year', '==', standardYear)
            .get()
            .then((querySnapshot) => {
                let gameQuestions = null;
                querySnapshot.forEach((doc) => {
                    gameQuestions = flattenDoc(doc);
                });
                console.log(gameQuestions)
                this.setState({
                    gameQuestions: gameQuestions,
                    loading: false,
                    init: true,
                });
            })
            .catch((error) => {
                console.error(error);
            });
        return true;
    }
    getPacingGuide = async () => {
        if (!(this.props.teacherBaseProps && this.props.teacherBaseProps.district &&
            this.props.pacingGuideBaseProps && this.props.pacingGuideBaseProps.standardYears &&
            this.props.pacingGuideBaseProps.activeYear
        )) {
            return false;
        }
        if (this.state.pacingGuidesDict.hasOwnProperty(this.state.standardCategory) &&
            this.state.pacingGuidesDict[this.state.standardCategory] &&
            this.state.pacingGuidesDict[this.state.standardCategory].hasOwnProperty(this.state.standardName) &&
            this.state.pacingGuidesDict[this.state.standardCategory][this.state.standardName]) {
            this.setState({
                pacingGuide: this.state.pacingGuidesDict[this.state.standardCategory][this.state.standardName]
            });
            return;
        }
        db.collection(ColType.pacingGuides)
            .where('standardName', '==', this.state.standardName)
            .where('standardCategory', '==', this.state.standardCategory)
            .where('districtId', '==', this.props.teacherBaseProps.district.id)
            .where('year', '==', this.props.pacingGuideBaseProps.activeYear)
            .limit(5)
            .get()
            .then((querySnapshot) => {
                let pacingGuide = null;
                querySnapshot.forEach((doc) => {
                    pacingGuide = flattenDoc(doc);
                })
                let pacingGuidesDict = this.state.pacingGuidesDict;
                if (!this.state.pacingGuidesDict.hasOwnProperty(this.state.standardCategory)) {
                    pacingGuidesDict[this.state.standardCategory] = {};
                }
                if (!this.state.pacingGuidesDict[this.state.standardCategory].hasOwnProperty(this.state.standardName)) {
                    pacingGuidesDict[this.state.standardCategory][this.state.standardName] = pacingGuide;
                }
                console.log(pacingGuidesDict, pacingGuide)
                this.setState({
                    pacingGuidesDict: pacingGuidesDict,
                    pacingGuide: pacingGuide
                });
            })
            .catch((error) => {
                console.log(error);
            });
    }
    setStandardCategory = (standardCategory) => {
        this.setState({
            standardCategory: standardCategory
        }, () => {
            this.getPacingGuide();
        });
    }
    setStandardName = (standardName) => {
        this.setState({
            standardName: standardName
        }, () => {
            this.getPacingGuide();
        });
    }
    setStandard = (standard) => {
        this.setState({
            standard: standard
        }, () => {
            this.getGameQuestions();
        });
    }
    setWeek = (week) => {
        this.setState({
            week: week,
        });
    }
    // Select a standard from a pacing guide card, then close the picker.
    selectStandard = (standardObj) => {
        this.setState({
            standard: standardObj.standard,
            standardTitle: standardObj.title || '',
            standardCategory: standardObj.standardCategory || this.state.standardCategory,
            standardName: standardObj.standardName || this.state.standardName,
            pickStandardVisible: false,
        }, () => {
            this.getGameQuestions();
        });
    }
    getAutoPlayGameType = () => {
        const gameTypes = ['castle', 'space', 'basketball', 'golf'];
        let autoPlayGameIdx = this.state.autoPlayGameIdx;
        let gameType = gameTypes[autoPlayGameIdx];
        autoPlayGameIdx += 1;
        if (autoPlayGameIdx > 3) {
            autoPlayGameIdx = 0;
        }
        this.setState({
            autoPlayGameIdx: autoPlayGameIdx
        });
        return gameType;
    }
    loadActiveYear = async () => {
        if (this.state.activeYear) return
        try {
            const doc = await db.collection(ColType.standardYears).doc('all').get()
            if (!doc.exists) return
            const standardYears = flattenDoc(doc)
            this.setState({ activeYear: standardYears.currentYear })
        } catch (e) {
            console.error('loadActiveYear', e)
        }
    }

    getStatYear = () => {
        return this.state.activeYear || null
    }

    canLogStats = () => {
        const t = this.props.teacherBaseProps
        return !!(t && t.teacher && t.district && !this.state.autoPlay && this.getStatYear())
    }

    recordAnswer = (isCorrect) => {
        if (isCorrect) this.sessionCorrect = (this.sessionCorrect || 0) + 1
        else this.sessionIncorrect = (this.sessionIncorrect || 0) + 1
    }

    startSession = (gameType) => {
        const now = Date.now()
        this.gameStartMs = now
        this.lastFlushMs = now
        this.activeGameType = gameType
        // snapshot the standard at start so a later menu change can't misattribute
        this.activeCategory = this.state.standardCategory
        this.activeName = this.state.standardName
        this.activeStandard = this.state.standard
        this.sessionCorrect = 0
        this.sessionIncorrect = 0
        this.sessionCounted = false
        this.paused = false
    }

    flushSession = () => {
        if (!this.activeGameType) return;
        if (!(this.props.teacherBaseProps &&
            this.props.teacherBaseProps.teacher &&
            this.props.teacherBaseProps.district)) {
            return;
        }
        const now = Date.now()
        let seconds = Math.round((now - (this.lastFlushMs || now)) / 1000)
        this.lastFlushMs = now
        if (seconds < 0) seconds = 0
        if (seconds > MAX_FLUSH_SECONDS) seconds = MAX_FLUSH_SECONDS

        const correct = this.sessionCorrect || 0
        const incorrect = this.sessionIncorrect || 0
        this.sessionCorrect = 0
        this.sessionIncorrect = 0
        const sessionInc = this.sessionCounted ? 0 : 1
        this.sessionCounted = true

        if (seconds === 0 && correct === 0 && incorrect === 0 && sessionInc === 0) return
        if (!this.canLogStats()) return

        const t = this.props.teacherBaseProps
        const teacher = t.teacher
        const districtId = t.district.id
        const schoolId = teacher.schoolId
        const year = this.getStatYear()
        const gameType = this.activeGameType
        const standardCategory = this.activeCategory   // subject: Math, ELA
        const standardName = this.activeName           // course: 5th Grade, Algebra
        const standard = this.activeStandard           // code: 3.NBT.1
        const id = statDocId(districtId, schoolId, year)

        const statBlock = {
            playtimeSeconds: inc(seconds),
            correct: inc(correct),
            incorrect: inc(incorrect),
            sessions: inc(sessionInc),
        }

        // --- base doc: flat totals + games + by_teacher(by subject) ---
        db.collection(ColType.gameStats).doc(id).set({
            districtId, schoolId, year,
            type: 'base',
            totalPlaytimeSeconds: inc(seconds),
            totalCorrect: inc(correct),
            totalIncorrect: inc(incorrect),
            totalSessions: inc(sessionInc),
            games: { [gameType]: statBlock },
            by_teacher: {
                [teacher.id]: {
                    firstName: teacher.firstName || '',
                    lastName: teacher.lastName || '',
                    categories: { [standardCategory]: { standardName, ...statBlock } },
                },
            },
        }, { merge: true }).catch((e) => console.error('gameStats base write', e))

        // --- subject doc: one standard code (nested object literal, dots safe) ---
        if (standardCategory && standard) {
            const suffix = SUBJECT_SUFFIX[standardCategory] || 'other'
            const subjectId = `${id}_${suffix}`          // districtId_schoolId_year_math
            db.collection(ColType.gameStats).doc(subjectId).set({
                districtId, schoolId, year, standardCategory,
                type: 'standards',                        // ← distinguishes it
                subject: suffix,                          // ← 'math','ela',... for querying
                standards: { [standard]: { standardName, ...statBlock } },
            }, { merge: true }).catch((e) => console.error('gameStats subject write', e))
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.gameType !== this.state.gameType) {
            if (prevState.gameType) { this.flushSession(); this.endSession(); }
            if (this.state.gameType) this.startSession(this.state.gameType);
        }
    }

    endSession = () => {
        this.activeGameType = null
        this.gameStartMs = null
    }

    componentWillUnmount() {
        if (this.activeGameType) this.flushSession()
        if (this._flushTimer) clearInterval(this._flushTimer)
        if (this._onVisibility) document.removeEventListener('visibilitychange', this._onVisibility)
    }


    render() {
        let linkTo = 'guide';
        let queryString = '';
        if (this.state.initialStandardCategory && this.state.initialStandardName && this.state.initialStandard) {
            linkTo = 'lesson-plan';
            queryString = '?category=' + this.state.initialStandardCategory + '&standardName=' +
                this.state.initialStandardName + '&standard=' + this.state.initialStandard + '&week=' + this.state.initialWeek + '&index=' + this.state.index;
        }
        let pacingGuideLink = this.props.teacherBaseProps.teacher ?
            '/teacher/pacing-guide/' + linkTo + '/' + this.props.teacherBaseProps.teacher.id + queryString
            :
            this.props.teacherBaseProps &&
                this.props.teacherBaseProps.admin ?
                '/admin/pacing-guide/' + linkTo + '/' + this.props.teacherBaseProps.admin.id + queryString
                :
                this.props.teacherBaseProps &&
                    this.props.teacherBaseProps.instructionalFacilitator ?
                    '/instructional-facilitator/pacing-guide/' + linkTo + '/' + this.props.teacherBaseProps.instructionalFacilitator.id + queryString
                    :
                    this.props.teacherBaseProps &&
                        this.props.teacherBaseProps.schoolAdmin ?
                        '/school-admin/pacing-guide/' + linkTo + '/' + this.props.teacherBaseProps.schoolAdmin.id + queryString
                        :
                        '';

        // Standards for the currently selected week of the loaded pacing guide.
        let weekStandards = [];
        if (this.state.pacingGuide &&
            this.state.pacingGuide.weeks &&
            this.state.pacingGuide.weeks.hasOwnProperty(this.state.week) &&
            Array.isArray(this.state.pacingGuide.weeks[this.state.week])) {
            weekStandards = this.state.pacingGuide.weeks[this.state.week];
        }

        return <div>
            <div style={{
                position: 'fixed',
                top: 0, left: 0,
                width: '100vw', height: '100vh',
                objectFit: 'cover',
                pointerEvents: 'auto',
                padding: '0px',
                zIndex: 5,
            }}>
                {!this.state.gameType ?
                    <div className='z-10-all'>
                        <img
                            src='/games/castle/castle-background.png'
                            alt='background'
                            style={{
                                position: 'fixed',
                                top: 0, left: 0,
                                width: '100vw', height: '100vh',
                                objectFit: 'cover',
                                pointerEvents: 'auto',
                            }}
                        />
                        <img src='/dotit-logo-color-new.png' alt='logo' height='37'
                            style={{ zIndex: '10', position: 'fixed', top: '24px', left: '20px' }} />
                        <Link to={pacingGuideLink}
                            size='large'
                            className={'ant-btn lg-btn ant-btn-primary flex flex-v-center'}
                            style={{ zIndex: '10', position: 'fixed', top: '17px', left: '173px' }}>
                            <Icon type='arrow-left' className='mr-05 font-20' />
                            <span>Go back</span>
                        </Link>
                        {/*<Button className='lg-btn ant-btn-primary'
                            style={{ zIndex: '10', position: 'fixed', top: '19px', left: '371px' }}
                            onClick={(e) => {
                                this.setState({
                                    autoPlay: true,
                                    gameType: this.getAutoPlayGameType(),
                                })
                            }}>
                            <Icon type='caret-right' className='mr-05 font-20' />
                            Demo Play
                        </Button>*/}
                        <div className='w-800 m-lr-auto relative mt-150 pt-3 text-center'>
                            <div className='flex flex-h-center w-100'>
                                <ImageBox src={'/games/castle/info-container.png'} style={{
                                    width: '42vh',
                                    height: '32vh',
                                    marginBottom: '0vh',
                                    padding: '2vh',
                                    marginTop: '0vh',
                                }} imgScale={2.2}
                                >
                                    <div>
                                        <div className='font-35 font-bold mb-1' style={{
                                            marginTop: '-4vh'
                                        }}>
                                            Standards-Based Games
                                        </div>
                                        <div className='font-20 font-bold mb-1' style={{ lineHeight: 1.2 }}>
                                            Standard: {this.state.standard}
                                        </div>
                                        <Button className='lg-btn flex flex-v-center' type='primary'
                                            onClick={(e) => {
                                                this.setState({
                                                    pickStandardVisible: true,
                                                })
                                            }}>
                                            <Icon type='read' className='mr-05 font-20' />
                                            Choose another standard
                                        </Button>
                                    </div>
                                </ImageBox>
                            </div>
                            {/*<div className='flex flex-h-center w-100'>
                                <ImageBox src={'/games/castle/scoreboard.png'} style={{
                                    width: '38vh',
                                    height: '15vh',
                                    marginBottom: '0vh',
                                    padding: '2vh',
                                    marginTop: '1vh',
                                }} imgScale={2.2}
                                >
                                    <div className='font-30 font-bold' style={{
                                        marginTop: '-2vh'
                                    }}>Pick a game!</div>
                                </ImageBox>
                            </div>*/}
                            {!this.state.init ?
                                <div></div>
                                :
                                this.state.init && !this.state.gameQuestions && !this.state.loading ?
                                    <div className='w-100 flex flex-h-center text-center mt-50 font-30 background-fff br-15 p-3'>
                                        <div>No games found, choose another standard.</div>
                                    </div>
                                    :
                                    this.state.init && this.state.loading ?
                                        <div className='w-100 flex flex-h-center text-center mt-50 font-30 background-fff br-15 p-3'>
                                            <div><Icon type="loading" className="mr-3" />Loading...</div>
                                        </div>
                                        :
                                        <div>

                                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px' }}>
                                                <ImageBox src={'/games/castle/question-container.png'} style={{
                                                    width: '44vh',
                                                    height: '16vh',
                                                    padding: '3vh',
                                                    paddingTop: '0vh',
                                                    marginTop: '3vh',
                                                    cursor: 'pointer',
                                                    textAlign: 'center'
                                                }} imgScale={1.8}
                                                    onClick={(e) => {
                                                        this.setState({
                                                            gameType: 'castle'
                                                        })
                                                    }}
                                                >
                                                    <div className='font-24 font-bold'>
                                                        <span className='font-30 mr-2'>🏰</span>
                                                        Castle Climb
                                                    </div>
                                                </ImageBox>
                                                <ImageBox src={'/games/space/information-container.png'} style={{
                                                    width: '44vh',
                                                    height: '15vh',
                                                    padding: '3vh',
                                                    paddingTop: '0vh',
                                                    marginTop: '3vh',
                                                    cursor: 'pointer',
                                                    textAlign: 'center'
                                                }} imgScale={1.8}
                                                    onClick={(e) => {
                                                        this.setState({
                                                            gameType: 'space'
                                                        })
                                                    }}
                                                >
                                                    <div className='font-24 font-bold font-fff mt-2'>
                                                        <span className='font-30 mr-2'>🚀</span>
                                                        Space Race
                                                    </div>
                                                </ImageBox>
                                                <ImageBox src={'https://firebasestorage.googleapis.com/v0/b/education-9d7f3.appspot.com/o/basketball-game-question-container.png?alt=media&token=3054d1f6-5335-4c79-b490-2d9d774d39bf'} style={{
                                                    width: '44vh',
                                                    height: '15vh',
                                                    padding: '3vh',
                                                    paddingTop: '0vh',
                                                    marginTop: '3vh',
                                                    cursor: 'pointer',
                                                    textAlign: 'center'
                                                }} imgScale={1.8}
                                                    onClick={(e) => {
                                                        this.setState({
                                                            gameType: 'basketball'
                                                        })
                                                    }}
                                                >
                                                    <div className='font-24 font-bold mt-3'>
                                                        <span className='font-30 mr-2'>🏀</span>
                                                        Basketball
                                                    </div>
                                                </ImageBox>
                                                <ImageBox src={'https://firebasestorage.googleapis.com/v0/b/education-9d7f3.appspot.com/o/golf-game-question-container.png?alt=media&token=41a0cfbc-e97a-4ab6-b948-47d510adb50d'} style={{
                                                    width: '44vh',
                                                    height: '15vh',
                                                    padding: '3vh',
                                                    paddingTop: '0vh',
                                                    marginTop: '3vh',
                                                    cursor: 'pointer',
                                                    textAlign: 'center'
                                                }} imgScale={1.8}
                                                    onClick={(e) => {
                                                        this.setState({
                                                            gameType: 'golf'
                                                        })
                                                    }}
                                                >
                                                    <div className='font-24 font-bold mt-2'>
                                                        <span className='font-30 mr-2'>⛳</span>
                                                        Golf
                                                    </div>
                                                </ImageBox>
                                            </div>
                                        </div>}
                        </div>
                        {this.state.pickStandardVisible ?
                            <div className='z-20-all' style={{
                                position: 'fixed',
                                top: 0, left: 0,
                                width: '100vw', height: '100vh',
                                pointerEvents: 'auto',
                                padding: '0px',
                            }}>
                                <img
                                    src='/games/castle/castle-background.png'
                                    alt='background'
                                    style={{
                                        position: 'fixed',
                                        top: 0, left: 0,
                                        width: '100vw', height: '100vh',
                                        objectFit: 'cover',
                                        zIndex: '20'
                                    }}
                                />
                                <Button className='lg-btn'
                                    type={'primary'}
                                    style={{ zIndex: '22', position: 'fixed', top: '12px', right: '12px' }}
                                    onClick={(e) => {
                                        this.setState({
                                            pickStandardVisible: false,
                                        })
                                    }}
                                >
                                    <Icon type='close' className='mr-05 font-20' />
                                    <span>Close</span>
                                </Button>
                                {/* Scrollable content layer over the fixed background */}
                                <div style={{
                                    position: 'fixed',
                                    top: 0, left: 0,
                                    width: '100vw', height: '100vh',
                                    overflowY: 'auto',
                                    overflowX: 'hidden',
                                    zIndex: '21',
                                    padding: '72px 24px 96px 24px',
                                    WebkitOverflowScrolling: 'touch',
                                }}>
                                    <div style={{ maxWidth: '1040px', margin: '0 auto' }}>
                                        {/* Steps 1-3 in a single row, 33% each */}
                                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px', alignItems: 'start' }}>

                                            <ImageBox src={'/games/castle/answer-container.png'} style={{
                                                width: '30vh',
                                                height: '15vh',
                                                padding: '3vh',
                                                paddingTop: '0vh',
                                                marginTop: '3vh',
                                                textAlign: 'center'
                                            }} imgScale={2.2}

                                            >
                                                <div className='text-left'>
                                                    <div className='font-16 mb-1'>
                                                        Step 1: Choose a Subject{<br />}(Optional)
                                                    </div>
                                                    <Select onChange={this.setStandardCategory}
                                                        value={this.state.standardCategory}
                                                        size='large' className='w-100'
                                                        style={{ maxWidth: '200px' }}>
                                                        {this.props.pacingGuideBaseProps &&
                                                            this.props.pacingGuideBaseProps.standardCategories &&
                                                            this.props.pacingGuideBaseProps.standardCategories.map((category, ind) => {
                                                                return <Select.Option key={'category-' + ind} value={category}>{category}</Select.Option>
                                                            })}
                                                    </Select>
                                                </div>
                                            </ImageBox>
                                            <ImageBox src={'/games/castle/answer-container.png'} style={{
                                                width: '30vh',
                                                height: '15vh',
                                                padding: '3vh',
                                                paddingTop: '0vh',
                                                marginTop: '3vh',
                                                textAlign: 'center'
                                            }} imgScale={2.2}

                                            >
                                                <div className='text-left'>
                                                    <div className='font-16 mb-1'>
                                                        Step 2: Choose a Grade Level (Optional)
                                                    </div>
                                                    <Select style={{ maxWidth: '200px' }} onChange={this.setStandardName} value={this.state.standardName} size='large' className='w-100'>
                                                        {this.props.pacingGuideBaseProps &&
                                                            this.props.pacingGuideBaseProps.standardNamesDict &&
                                                            this.props.pacingGuideBaseProps.standardNamesDict.hasOwnProperty(this.state.standardCategory) &&
                                                            this.props.pacingGuideBaseProps.standardNamesDict[this.state.standardCategory].map((standardName, ind) => {
                                                                return <Select.Option key={'grade-' + ind} value={standardName}>{standardName}</Select.Option>
                                                            })}
                                                    </Select>
                                                </div>
                                            </ImageBox>
                                            <ImageBox src={'/games/castle/answer-container.png'} style={{
                                                width: '30vh',
                                                height: '15vh',
                                                padding: '3vh',
                                                paddingTop: '0vh',
                                                marginTop: '3vh',
                                                textAlign: 'center'
                                            }} imgScale={2.2}

                                            >
                                                <div className='text-left'>
                                                    <div className='font-16 mb-1'>
                                                        Step 3: Choose a Quarter and Week (Optional)
                                                    </div>
                                                    <Select
                                                        onChange={this.setWeek}
                                                        value={this.state.week}
                                                        placeholder="Select a week"
                                                        size="large"
                                                        className="w-100"
                                                        style={{ maxWidth: '200px' }}
                                                    >
                                                        {this.props.pacingGuideBaseProps &&
                                                            this.props.pacingGuideBaseProps.weekNums &&
                                                            this.props.pacingGuideBaseProps.weekNums.map((weekNum, ind) => {
                                                                if (weekNum === 0) return null;
                                                                const weekInQuarter = getWeekInQuarter(weekNum);
                                                                return (
                                                                    <Select.Option key={'weekNum-' + ind} value={weekNum}>
                                                                        {'Quarter ' + weekInQuarter.quarter + ', Week ' + weekInQuarter.weekInQuarter}
                                                                    </Select.Option>
                                                                );
                                                            })}
                                                    </Select>
                                                </div>
                                            </ImageBox>



                                        </div>

                                        <ImageBox src={'/games/castle/question-container.png'} style={{
                                            width: '41vh',
                                            height: '15vh',
                                            padding: '3vh',
                                            paddingTop: '0vh',
                                            marginTop: '9vh',
                                            marginBottom: '2vh',
                                            textAlign: 'center'
                                        }} imgScale={2.2}

                                        >
                                            <div className='text-left'>
                                                {/* Step 4: standards, full width under steps 1-3 */}
                                                <div className=' p-2 font-16 text-left'>
                                                    Step 4: Choose a Standard
                                                </div>
                                            </div>
                                        </ImageBox>


                                        {weekStandards.length > 0 ?
                                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '12px' }}>
                                                {weekStandards.map((standard, standardIdx) => {
                                                    const isSelected = this.state.standard === standard.standard;
                                                    return <div
                                                        key={'standard-' + standardIdx}
                                                        className='background-fff p-3 br-15 text-left'
                                                        style={{
                                                            cursor: 'pointer',
                                                            border: isSelected ? '3px solid #1890ff' : '3px solid transparent',
                                                            transition: 'border 0.15s ease, transform 0.15s ease',
                                                        }}
                                                        onClick={(e) => { this.selectStandard(standard); }}
                                                        onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-2px)'; }}
                                                        onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0px)'; }}
                                                    >
                                                        <div className='font-20 font-bold mb-05'>{standard.standard}</div>
                                                        <div className='font-16'>{standard.title}</div>
                                                    </div>
                                                })}
                                            </div>
                                            :
                                            <div className='background-fff p-3 font-16 br-15 text-left'>
                                                No standards found for this selection. Try choosing a different subject, grade, or week.
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            : ''}
                    </div>
                    : ''}
                {this.state.gameType === 'castle' ?
                    <div>
                        {this.state.gameQuestions ?
                            <CastleGame onAnswered={this.recordAnswer} autoPlay={this.state.autoPlay} autoPlayOnComplete={() => {
                                setTimeout(() => {
                                    this.setState({
                                        gameType: this.getAutoPlayGameType()
                                    })
                                }, 1500);
                            }} gameQuestions={this.state.gameQuestions} key={'castle-' + this.state.gameQuestions.standardCategory + '-' +
                                this.state.gameQuestions.standardName + '-' + this.state.gameQuestions.standard
                            } />
                            : ''}
                        <img src='/dotit-logo-color-new.png' alt='logo' height='37'
                            style={{ zIndex: '10', position: 'fixed', top: '24px', left: '20px' }} />
                        <Button className='lg-btn'
                            type={'primary'}
                            style={{ zIndex: '10', position: 'fixed', top: '12px', right: '12px' }}
                            onClick={(e) => {
                                this.setState({
                                    gameType: '',
                                    autoPlay: false,
                                })
                            }}
                        >
                            <Icon type='close' className='mr-05 font-20' />
                            <span>Quit</span>
                        </Button>
                    </div>
                    : ''}
                {this.state.gameType === 'space' ?
                    <div>
                        {this.state.gameQuestions ?
                            <SpaceGame onAnswered={this.recordAnswer} autoPlay={this.state.autoPlay} autoPlayOnComplete={() => {
                                setTimeout(() => {
                                    this.setState({
                                        gameType: this.getAutoPlayGameType()
                                    })
                                }, 1500);
                            }} gameQuestions={this.state.gameQuestions} key={'space-' + this.state.gameQuestions.standardCategory + '-' +
                                this.state.gameQuestions.standardName + '-' + this.state.gameQuestions.standard
                            } />
                            : ''}
                        <img src='/dotit-logo-new.png' alt='logo' height='37'
                            style={{ zIndex: '10', position: 'fixed', top: '24px', left: '20px' }} />
                        <Button className='lg-btn'
                            type={'primary'}
                            style={{ zIndex: '10', position: 'fixed', top: '12px', right: '12px' }}
                            onClick={(e) => {
                                this.setState({
                                    gameType: '',
                                    autoPlay: false,
                                })
                            }}
                        >
                            <Icon type='close' className='mr-05 font-20' />
                            <span>Quit</span>
                        </Button>
                    </div>
                    : ''}
                {this.state.gameType === 'basketball' ?
                    <div>
                        {this.state.gameQuestions ?
                            <BasketballGame onAnswered={this.recordAnswer} autoPlay={this.state.autoPlay} autoPlayOnComplete={() => {
                                setTimeout(() => {
                                    this.setState({
                                        gameType: this.getAutoPlayGameType()
                                    })
                                }, 1500);
                            }} gameQuestions={this.state.gameQuestions} key={'castle-' + this.state.gameQuestions.standardCategory + '-' +
                                this.state.gameQuestions.standardName + '-' + this.state.gameQuestions.standard
                            } />
                            : ''}
                        <img src='/dotit-logo-color-new.png' alt='logo' height='37'
                            style={{ zIndex: '10', position: 'fixed', top: '24px', left: '20px' }} />
                        <Button className='lg-btn'
                            type={'primary'}
                            style={{ zIndex: '10', position: 'fixed', top: '12px', right: '12px' }}
                            onClick={(e) => {
                                this.setState({
                                    gameType: '',
                                    autoPlay: false,
                                })
                            }}
                        >
                            <Icon type='close' className='mr-05 font-20' />
                            <span>Quit</span>
                        </Button>
                    </div>
                    : ''}
                {this.state.gameType === 'golf' ?
                    <div>
                        {this.state.gameQuestions ?
                            <GolfGame onAnswered={this.recordAnswer} autoPlay={this.state.autoPlay} autoPlayOnComplete={() => {
                                setTimeout(() => {
                                    this.setState({
                                        gameType: this.getAutoPlayGameType()
                                    })
                                }, 1500);
                            }} gameQuestions={this.state.gameQuestions} key={'castle-' + this.state.gameQuestions.standardCategory + '-' +
                                this.state.gameQuestions.standardName + '-' + this.state.gameQuestions.standard
                            } />
                            : ''}
                        <img src='/dotit-logo-color-new.png' alt='logo' height='37'
                            style={{ zIndex: '10', position: 'fixed', top: '24px', left: '20px' }} />
                        <Button className='lg-btn'
                            type={'primary'}
                            style={{ zIndex: '10', position: 'fixed', top: '12px', right: '12px' }}
                            onClick={(e) => {
                                this.setState({
                                    gameType: '',
                                    autoPlay: false,
                                })
                            }}
                        >
                            <Icon type='close' className='mr-05 font-20' />
                            <span>Quit</span>
                        </Button>
                    </div>
                    : ''}
            </div>
            <div className='z-20-all' style={{
                position: 'fixed',
                bottom: 6, left: 4
            }}>
                <div className='relative-all font-fff-all br-15' style={{
                    background: 'rgba(23,31,42,0.92)',
                    maxHeight: '28px',
                }}>
                    <div className='absolute-tl' style={{ top: '-11px' }}>
                        <CustomFooter showTerms={false} additionalClassName='pl-12px' />
                    </div>
                </div>
            </div>
        </div>
    }
}
export default Games